import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import Button from '@material-ui/core/Button';
import {useDispatch, useSelector} from "react-redux";
import {
  disableUserEarlyAccess,
  enableUserEarlyAccess, setUserEmailVerified,
  setUserIsActiveAction, setUserIsApprovedAction,
  setUserNeedsPasswordResetAction
} from "../../../../actions";
import {Badge} from "reactstrap";
import red from "@material-ui/core/colors/red";
// import {Tooltip} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  color1: {
    backgroundColor: green[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  color2: {
    backgroundColor: red[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

const ToggleButton = (props) => {

  const {classes,
    userId,
    // user,
    userProperty,
    toolTip = null,
    disableInteraction = false,
    flipColorLogic = false,
    earlyAccessTags = null,} = props;
  const {users} = useSelector(({users}) => users);
  const user = users ? users[userId] ? users[userId] : null : null;
  const userPropertyState = user ? user[userProperty] ? user[userProperty] : null : null;

  const [localLoading, setLocalLoading] = useState(false);
  const [localPropertyState, setLocalPropertyState] = useState(userPropertyState)

  let propertyDisplayName;

  if(userProperty ==="is_active"){
    if(localPropertyState){
      propertyDisplayName = "Deactivate";
    } else{
      propertyDisplayName = "Reactivate";
    }
  } else if(userProperty === "resetPw"){
    if(localPropertyState){
      propertyDisplayName = "Password Reset Pending";
    }else{
      propertyDisplayName = "Force Password Reset";
    }
  } else if(userProperty === "hasEarlyAccess"){
    if(localPropertyState){
      propertyDisplayName = "Disable";
    }else{
      propertyDisplayName = "Enable";
    }
  } else if(userProperty === "is_activated"){
    if(localPropertyState){
      propertyDisplayName = "Verified"
    }else{
      propertyDisplayName = "Not Verified"
    }
  }else{
    propertyDisplayName = "Button"
  }


  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("printing a user toggle switch for user, ", userId, user);
    setLocalLoading(false);
    setLocalPropertyState(userPropertyState);
  }, [users, user, dispatch]);


  const handleButtonClick = (event) => {
    if (!localLoading) {
      //setLoading(true);
      //TODO: handle the requerst then set loading to false and success
      if (user && !disableInteraction) {
        switch (userProperty) {
          case "is_active":
            setLocalLoading(true);
            dispatch(setUserIsActiveAction({"userId": userId, "newIsActiveStatus": !userPropertyState}));
            setLocalPropertyState(!localPropertyState);
            break;

          case "resetPw":
            setLocalLoading(true);
            dispatch(setUserNeedsPasswordResetAction({"userId": userId, "newNeedsPasswordResetStatus": !userPropertyState}));
            setLocalPropertyState(!localPropertyState)
            break;

          case "approved":
            setLocalLoading(true);
            dispatch(setUserIsApprovedAction({"userId": userId, "newIsApprovedStatus": !userPropertyState}));
            setLocalPropertyState(!localPropertyState)
            break;

          case "is_activated":
            console.log("This should dispatch the api aciton... ")
            setLocalLoading(true);
            dispatch(setUserEmailVerified(userId, !userPropertyState));
            // setLocalPropertyState(!localPropertyState)
            break;

          case "hasEarlyAccess":
            setLocalLoading(true);
            if(earlyAccessTags && earlyAccessTags.length > 0){
              dispatch(disableUserEarlyAccess(earlyAccessTags[0], userId))
              setLocalPropertyState(!localPropertyState)
              // console.log("disable existing tag")
            } else{
              dispatch(enableUserEarlyAccess(userId))
              setLocalPropertyState(!localPropertyState)
              // console.log("enable tag")
            }
            break;

          default:
            break;
        }
        setLocalLoading(false);
      }
    }
  };

  const buttonClassname = classNames({
    [classes.color1]: flipColorLogic? !localPropertyState : localPropertyState,
    [classes.color2]: flipColorLogic? localPropertyState : !localPropertyState,
  });


  return (
          <div className={classes.root}>
            <div className={classes.wrapper}>
            {/*<div className={classes.wrapper}>*/}
            {/*  <Fab color="default" className={buttonClassname} onClick={(event) => handleButtonClick(event)}>*/}
            {/*    {userPropertyState ? <StopSharpIcon/> : <PlayArrowSharpIcon/>}*/}
            {/*  </Fab>*/}
            {/*  {localLoading && <CircularProgress size={68} className={classes.fabProgress}/>}*/}
            {/*</div>*/}
            {/*<div className={classes.wrapper}>*/}
            {/*  <Button*/}
            {/*    variant="contained"*/}
            {/*    color="default"*/}

            {/*  >*/}
            {/*    /!*{customer ? isStromboliActive ? "Stop Continuous Attacks" : "Start Continuous Attacks" : "Loading..."}*!/*/}
            {/*    {propertyDisplayName}*/}
            {/*  </Button>*/}
            {/*  {localLoading && <CircularProgress size={24} className={classes.buttonProgress}/>}*/}
            {/*</div>*/}
            {localLoading && <CircularProgress size={30} className={classes.buttonProgress}/>}
              <Tooltip title={toolTip}><span>
                <Badge
                    // color={color}
                    className={buttonClassname}
                    disabled={disableInteraction ? true : localLoading}
                    onClick={(event) => handleButtonClick(event)}
                    type={disableInteraction ? "" : "Button"}
                >
                  {propertyDisplayName}
                </Badge>
                </span>

              </Tooltip>

            </div>

          </div>
  );

}

ToggleButton.propTypes = {
  classes: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  userProperty: PropTypes.string.isRequired,
  propertyDisplayName: PropTypes.string.isRequired,
  toolTip: PropTypes.string,
  disableInteraction: PropTypes.bool,
  flipColorLogic: PropTypes.bool,
};

export default withStyles(styles)(ToggleButton);